import { useEffect, useState } from "react";
import { apiFetchJson } from "../apiClient";

/** Current backend upload limits and the workspace's document types (feature 3)
 * from GET /documents/upload-config?database=. null until the config has
 * loaded; callers fall back to the documented backend defaults via
 * ../utils/uploadValidate while it's pending. */
export default function useUploadConfig(database) {
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    let stale = false;
    setCfg(null);
    const query = database ? `?database=${encodeURIComponent(database)}` : "";
    apiFetchJson(`/api/v1/documents/upload-config${query}`)
      .then((config) => {
        if (!stale) setCfg(config);
      })
      .catch(() => {
        // Leave cfg null — uploadValidate's documented defaults apply.
      });
    return () => {
      stale = true;
    };
  }, [database]);
  return cfg;
}
